/**
 * 头像兜底工具：当用户/主播头像为空或加载失败时，
 * 生成「昵称首字 + 渐变背景」的精致 SVG 头像，避免显示公司 logo 等假占位。
 */

const GRADIENTS = [
  ['#ff9a9e', '#fecfef'],
  ['#a18cd1', '#fbc2eb'],
  ['#fbc2eb', '#a6c1ee'],
  ['#84fab0', '#8fd3f4'],
  ['#fccb90', '#d57eeb'],
  ['#e0c3fc', '#8ec5fc'],
  ['#f093fb', '#f5576c'],
  ['#4facfe', '#00f2fe'],
  ['#43e97b', '#38f9d7'],
  ['#fa709a', '#fee140'],
  ['#30cfd0', '#330867'],
  ['#a8edea', '#fed6e3']
];

/**
 * 生成首字渐变头像（data URI）
 * @param {String} name 昵称/艺名
 * @param {Number} seed 用于挑选渐变配色的种子（如用户ID），相同用户得到一致头像
 * @returns {String} SVG data URI
 */
export function avatarFallback(name = '', seed = 0) {
  const idx = Math.abs(Number(seed) || 0) % GRADIENTS.length;
  const [c1, c2] = GRADIENTS[idx];
  const ch = (String(name || '').trim().charAt(0) || '灵');
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160">' +
    '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
    `<stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/>` +
    '</linearGradient></defs>' +
    '<rect width="160" height="160" rx="80" fill="url(#g)"/>' +
    `<text x="80" y="112" font-size="76" font-family="PingFang SC, Microsoft YaHei, sans-serif" font-weight="bold" fill="#ffffff" text-anchor="middle">${ch}</text>` +
    '</svg>';
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}
